module.exports = __webpack_public_path__ + "static/media/cart-fill-white.fe622786.svg";